import { Card, Row, Tabs } from 'antd';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import OrganizationStatisticsPage from './organization-statistics/organization-statistics-page';
import { OrganizationStatisticsState } from 'src/stores/statistics-store';
import OrganizationStatisticsChartPage from './organization-statistics/organization-statistics-charts-page';
import { useIdentity } from 'src/core/services/authentication';

const StatisticsPage: FC = () => {
  const { t } = useTranslation();
  const identity = useIdentity();
  setHeader(t('Statistics'));
  setRoutes([
    { path: '', breadcrumbName: t('Home') },
    { path: 'statistics', breadcrumbName: t('Statistics') },
  ]);

  const [queryState, setQueryState] = useState<OrganizationStatisticsState>({
    query: {
      startDate: undefined,
      endDate: undefined,
      mostUsed: false,
      partnerTenantId: identity?.profile['tenant_id'],
    },
    selectorLabel: undefined,
  });

  return (
    <Row align="top" justify="space-between">
      <Card className="card-table" style={{ width: '100%' }}>
        <Row align="top" justify="space-between">
          <Tabs
            destroyInactiveTabPane
            defaultActiveKey="1"
            style={{ width: '100%', height: '100%', marginLeft: '20px', marginRight: '20px', marginBottom: '20px' }}
          >
            <Tabs.TabPane tab={t('Organizations')} key="1" style={{ border: 'none' }}>
              <OrganizationStatisticsPage queryState={queryState} setQueryState={setQueryState} />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Charts')} key="2" style={{ border: 'none' }}>
              <OrganizationStatisticsChartPage queryState={queryState} setQueryState={setQueryState} />
            </Tabs.TabPane>
          </Tabs>
        </Row>
      </Card>
    </Row>
  );
};

export default StatisticsPage;
